import { render, staticRenderFns } from "./taskCategoryRuleConfig.vue?vue&type=template&id=55f408cc&scoped=true"
import script from "./taskCategoryRuleConfig.vue?vue&type=script&lang=js"
export * from "./taskCategoryRuleConfig.vue?vue&type=script&lang=js"
import style0 from "./taskCategoryRuleConfig.vue?vue&type=style&index=0&id=55f408cc&prod&lang=less&scoped=true"
import style1 from "./taskCategoryRuleConfig.vue?vue&type=style&index=1&id=55f408cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f408cc",
  null
  
)

export default component.exports